import axios from '@axios'
import constants from '@/app-configs/constants'
// import cases from './cases'
// import debtor from './debtor'
import apitokens from './apitokens'

// async function getTranslations() {
//   const { data } = await axios.get('translations/system-locales')

//   return data.data.map(e => ({
//     title: e.language,
//     route: {
//       name: 'translations',
//       params: { lang: e.code },
//       meta: {
//         navActiveLink: e.code,
//       },
//       icon: 'GridIcon',
//     },

//   }))
// }

async function getSuperAdminTranslations() {
  const { data } = await axios.get('translations/system-locales')

  return data.data.map(e => ({
    title: e.language,
    route: {
      name: 'translations',
      params: { lang: e.code },
      meta: {
        navActiveLink: e.code,
      },
      icon: 'GridIcon',
    },
    action: constants.action.permissionTranslationView,
    resource: constants.resource.translation,

  }))
}

export default async function mainComponent() {
  return [
    {
      title: 'DEBTIA_HOME',
      route: 'home',
      icon: 'HomeIcon',
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    },
    {
      title: 'DEBTIA_TRANSLATIONS',
      route: 'translations',
      action: constants.action.permissionTranslationView,
      resource: constants.resource.translation,
      children: await getSuperAdminTranslations(),
    },
    {
      title: 'DEBTIA_ROLE_MANAGEMENT',
      route: 'role-management',
      icon: 'GridIcon',
      action: constants.action.permissionRoleView,
      resource: constants.resource.role,
    },
    {
      title: 'DEBTIA_USERS',
      icon: 'UserIcon',
      action: constants.action.permissionUserView,
      resource: constants.resource.user,
      route: 'users-list',
    },
    // ...cases,
    // ...debtor,
    ...apitokens,
    {
      title: 'DEBTIA_API_SETTINGS',
      icon: 'GridIcon',
      route: 'apisettings',
      action: constants.action.permissionUserSettings,
      resource: constants.resource.user,
    },
    // {
    //   title: 'DEBTIA_ADMIN_SETTINGS',
    //   icon: 'GridIcon',
    //   route: 'adminsettings',
    //   action: constants.action.permissionLogin,
    //   resource: constants.resource.user,
    // },
  ]
}
